const routes = {
  SIGN_IN: "/sign_in",
  RESET_PASSWORD: "/reset",
  REGISTER: '/register',
  ENROLLMENT: "/enrollment",
  // Station View
  OVERVIEW: "/overview",
  MONITOR: "/monitor",
  DEVICE_LIST: "/devices",
  DEVICE_DETAIL: "/devices/:deviceId",
  CREDIT_LIST: "/credit",
  DEVICE_ADD: "/add_device",
  USER_LIST: "/users/list",
  USER_INVITATION_LIST: "/users/invitation",
  DATA_LIST: "/history_data",
  JUMPING: "/jumping",
  // Admin View
  ADMIN: "/admin",
  ADMIN_DASHBOARD: "/admin/dashboard",
  // 站点
  ADMIN_STATIONS: "/admin/stations",
  ADMIN_ADD_STATION: "/admin/add_stations",
  ADMIN_EDIT_STATION: "/admin/stations/edit/:stationId",
  // 设备类型
  ADMIN_DEVICE_TYPES: "/admin/device_types",
  ADMIN_ADD_DEVICE_TYPE_DETAIL: "/admin/device_types/:deviceTypeId",
  ADMIN_ADD_DEVICE_TYPE: "/admin/add_device_type",
  ADMIN_EDIT_DEVICE_TYPE: "/admin/edit_device_type/:deviceTypeId",

  // 用户
  ADMIN_USERS: "/admin/users",
  ADMIN_ADD_USER: "/admin/add_user",
};

export default routes;
